module.exports = __webpack_public_path__ + "static/reg-large8-a67aa42aa5abbc1f1eaffb61b70d7a9f.jpg";